export const GET_FEEDBACK_ANALYTICS_START =
  'FEEDBACK_ANALYTICS::GET_FEEDBACK_ANALYTICS_START';
export const GET_FEEDBACK_ANALYTICS_SUCCESS =
  'FEEDBACK_ANALYTICS::GET_FEEDBACK_ANALYTICS_SUCCESS';
export const GET_FEEDBACK_ANALYTICS_FAIL =
  'FEEDBACK_ANALYTICS::GET_FEEDBACK_ANALYTICS_FAIL';

export const CLEAR_FEEDBACK_ANALYTICS_DATA = 'FEEDBACK_ANALYTICS::CLEAR_DATA';
